<!--
Fork addition (Stage I): on mobile the toolbox is a full-screen step —
once a factory is picked for placement, close it so the board (where
the placement tap lands) is what the user sees.

This subscription lives in its own headless component on purpose:
usePointAndClick is a shared composable whose factory injects the
settings, and a component can never inject its OWN provides — the
first call has to happen in a descendant of main-window, which is
what provides the settings. Stage I originally subscribed from
main-window's onBeforeMount; the factory then threw
"settings not instantiated", aborting the hook before the model was
published and leaving the app on the loading spinner forever
(regression found and fixed 2026-10-16).
-->
<script setup lang="ts">
import {unref, watch} from 'vue';
import {useIsMobile} from '@/composables';
import {SelectedClassType, usePointAndClick} from '@/composables/drag-helpers';

const emit = defineEmits<{
    (e: 'close'): void;
}>();

const {isMobile} = useIsMobile();
const {selectedItem} = usePointAndClick();

watch(selectedItem, (selection) => {
    if(unref(isMobile) && selection && (selection.clazz === SelectedClassType.Item))
        emit('close');
});
</script>

<template>
    <!-- headless: behaviour only, renders nothing -->
</template>
